import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const posStatusListWidget: DashboardWidgetConfiguration = {
  widgetId: "pos.status-list",
  name: "Orders by status",
  description: "Orders by status as a compact RQL list.",
  apps: [
    "point-of-sale",
  ],
  template: "list",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "pos.orders",
      ...period(30),
      select: [
        {
          type: "field",
          field: "status",
          as: "status",
        },
        {
          type: "aggregate",
          function: "count_distinct",
          field: "record_id",
          as: "orders",
        },
      ],
      group_by: [
        {
          field: "status",
        },
      ],
      order_by: [
        {
          ref: "orders",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Orders by status",
    columns: [
      {
        key: "status",
        label: "Status",
      },
      {
        key: "orders",
        label: "Orders",
        align: "end",
        format: "number",
      },
    ],
    maxRows: 8,
    showAccountTypeDescription: false,
  },
  dummyData: {
    rows: [
      {
        status: "Paid",
        orders: 312,
      },
      {
        status: "Pending",
        orders: 42,
      },
      {
        status: "Refunded",
        orders: 8,
      },
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
